'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('violations-ticket-edit', {
      url: '/violation/ticket/edit/:id',
      params: {propertyId: null},
      template: '<violations-ticket-edit></violations-ticket-edit>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/violations/ticket-edit/violations-ticket-edit.routes.js